import { useEffect, useState } from 'react';

import logoSvg from '../../images/logos/insight_powered_by.svg';

const JourneyInsight = ({ playlist, onChange, customer }) => {

    const [hasError, setHasError] = useState(false);

    const EMBED_VALUES = {
        airpots : '1-4BMvGUNDPY5rixB30YOl2Q',
        conferencesAndEvents: '1-7jFBoOAhoJCknthLKATt6b',
        hospitality : '1-0nFbY2VuTdZbQmshYPYTL',
        multifamilyResidential: '1-7txUp3wZl5iPfIQ6KUxFSF',
        retail : '1-3Vn3AwKPFDQTkVSqqpOvk6',
        sportsAndEntertainment: '1-1NDtP1aEb7V7SJe1mga0Ta',
        transportationAgencies: '1-1pUJdqXEVdWDrq09GxDHIS',
        tma : '1-3uu4bU2ith50z8i2AosRW5',
        universitiesAndCampuses: '1-4e9KrFQwZ8FD4yenxim6ON',
        workplacesAndHumanResources: '1-VEmbgXxiXFbLuZ86hqCZ8'
    }

    const embedId = EMBED_VALUES[playlist?.usageType];
    const embedUrl = embedId ? `https://app.sigmacomputing.com/embed/${embedId}?ReportID-1=${playlist.id}` : null;

    useEffect(() => {
        setHasError(false);
    }, [embedUrl]);

    return (
        <div className="InsightMotionalIntelligence">
            <div className="insight-motional-intelligence-contents">
                <div className="placeholder">
                    {embedUrl && !hasError ? (
                        <iframe src={embedUrl} onError={() => setHasError(true)} />
                    ) : (
                        <div className="insight-unavailable">Insight is unavailable for this playlist.</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default JourneyInsight;
